module.exports = __webpack_public_path__ + "static/img/emptyData.5b204e3c.png";